import { USER } from "../../../../pool";
import axiom from "../../../../utils/axiom";

export const getUserDetails = (clientId) =>
  axiom.get(USER.base + USER.paths.getClient + clientId);

export const updateUserStatus = (details) =>
  axiom.patch(USER.base + USER.paths.approveUser, details);
